import { render } from "./PendingSales.vue?vue&type=template&id=132f4f05&scoped=true"
import script from "./PendingSales.vue?vue&type=script&lang=js"
export * from "./PendingSales.vue?vue&type=script&lang=js"

import "./PendingSales.vue?vue&type=style&index=0&id=132f4f05&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132f4f05"]])

export default __exports__